/**
 * 学员科目学分导入
 */
import React from "react";
import {connect} from 'dva';
import 'antd/dist/antd.css';
import {component_tool, framework_tool} from '@/tool';
import {modelUtils} from '@/utils';
import {ExportExcel} from '@/components/index';

let {WizContainer} = framework_tool;
let {WizSpin, WizTypography} = component_tool;
const {Paragraph} = WizTypography;

class SubjectCreditPersonImport extends WizContainer {
  componentName = 'subjectCreditPersonImport';

  constructor(props) {
    super(props);
    this.state = {}
  }


  _render() {
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3. 当完成Excel文件的填写后，点击“上传文件”按钮上传此文件，并点击“导入”系统会校验数据的正确性，并提示错误的数据；在校验无错误的情况下，将数据导入到系统中。</Paragraph>,
      ]
    }
    let excelFile = constants.files.excel_subjectCreditRecordPersonTemp;
    let operateProps = {
      title: '导入个人科目学分',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: excelFile,
      }
    }
    let submit = (file, fileData) => {
      if (this.props.importSubjectCredit) {
        this.props.importSubjectCredit({
          fileData: fileData,
        })
      }
    }
    let {subjectCreditRecordLoading} = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={subjectCreditRecordLoading}>
        <ExportExcel
          key={new Date().getTime()}
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {subjectCreditRecord} = state;
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'subjectCreditRecord')
  return {
    ...load
  }
};
export default connect(mapStateToProps)(SubjectCreditPersonImport);
